var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("headroom", { attrs: { "z-index": 1000 } }, [
        _c("header", { staticClass: "main-header" }, [
          _c(
            "div",
            { staticClass: "container main-header__inner" },
            [
              _c(
                "router-link",
                {
                  staticClass: "main-header__logo",
                  attrs: { to: { name: "home" } }
                },
                [
                  _c("img", {
                    attrs: {
                      src: "/img/logo.png/300x0_ratio/logo.png",
                      alt: "Logo"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "main-header__nav" }, [
                _c(
                  "nav",
                  { staticClass: "main-header__navigation" },
                  [
                    _c("menu-component", {
                      attrs: {
                        pages: _vm.$store.state.navigation.items,
                        "list-class": "main-header__list",
                        "submenu-class": "main-header__sub",
                        "item-class": "main-header__item",
                        "link-class": "main-header__link"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$store.state.languages.length > 1
                  ? _c(
                      "div",
                      { staticClass: "main-header__lang" },
                      [_c("language-switch-component")],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mobile-nav__action" }, [
        _c("div", { staticClass: "d-flex align-items-center pl-1" }, [
          _c(
            "a",
            {
              staticClass: "mobile-nav__link mr-2",
              attrs: {
                href: "tel:805-688-2628",
                "data-ga-track": "",
                "data-ga-category": "Phone",
                "data-ga-action": "call",
                "data-ga-label": "805-688-2628"
              }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "svg-inline--fa fa-phone fa-w-16",
                  attrs: {
                    width: "25px",
                    height: "25px",
                    "aria-hidden": "true",
                    "data-prefix": "fal",
                    "data-icon": "phone",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d:
                        "M487.8 24.1L387 .8c-14.7-3.4-29.8 4.2-35.8 18.1l-46.5 108.5c-5.5 12.7-1.8 27.7 8.9 36.5l53.9 44.1c-34 69.2-90.3 125.6-159.6 159.6l-44.1-53.9c-8.8-10.7-23.8-14.4-36.5-8.9L18.9 351.3C5 357.3-2.6 372.3.8 387L24 487.7C27.3 502 39.9 512 54.5 512 306.7 512 512 307.8 512 54.5c0-14.6-10-27.2-24.2-30.4zM55.1 480l-23-99.6 107.4-46 59.5 72.8c103.6-48.6 159.7-104.9 208.1-208.1l-72.8-59.5 46-107.4 99.6 23C479.7 289.7 289.6 479.7 55.1 480z"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "mobile-nav__link mr-2",
              attrs: {
                href: "mailto:infocustomarchstone@gmail.com",
                "data-ga-track": "",
                "data-ga-category": "E-Mail",
                "data-ga-action": "click",
                "data-ga-label": "infocustomarchstone@gmail.com"
              }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "svg-inline--fa fa-envelope fa-w-16",
                  attrs: {
                    width: "25px",
                    height: "25px",
                    "aria-hidden": "true",
                    "data-prefix": "fal",
                    "data-icon": "envelope",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d:
                        "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "mobile-nav__link mr-2",
              attrs: {
                href: "https://goo.gl/maps/zG9dMYMihwbWzad4A",
                target: "_blank",
                "data-ga-track": "",
                "data-ga-category": "Map",
                "data-ga-action": "click"
              }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "svg-inline--fa fa-map-marker-alt fa-w-12",
                  attrs: {
                    width: "25px",
                    height: "25px",
                    "aria-hidden": "true",
                    "data-prefix": "fal",
                    "data-icon": "map-marker-alt",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 384 512"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d:
                        "M192 96c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm0-256C85.961 0 0 85.961 0 192c0 77.413 26.97 99.031 172.268 309.67 9.534 13.772 29.929 13.774 39.465 0C357.03 291.031 384 269.413 384 192 384 85.961 298.039 0 192 0zm0 473.931C52.705 272.488 32 256.494 32 192c0-42.738 16.643-82.917 46.863-113.137S149.262 32 192 32s82.917 16.643 113.137 46.863S352 149.262 352 192c0 64.49-20.692 80.47-160 281.931z"
                    }
                  })
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-nav__hamburger" }, [
          _c(
            "button",
            {
              staticClass: "hamburger hamburger--spin",
              class: { "is-active": _vm.$store.state.navigation.isOpen },
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$store.dispatch("navigation/toggle")
                }
              }
            },
            [_vm._m(0)]
          )
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "mobile-nav" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$store.state.navigation.isOpen,
                expression: "$store.state.navigation.isOpen"
              }
            ],
            staticClass: "mobile-nav"
          },
          [
            _c(
              "nav",
              { staticClass: "main-header__navigation" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "main-header__logo mb-3",
                    attrs: { to: { name: "home" } }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/img/logo.png/300x0_ratio/logo.png",
                        alt: "Logo"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("menu-component", {
                  attrs: {
                    pages: _vm.$store.state.navigation.items,
                    "list-class": "main-header__list",
                    "submenu-class": "main-header__sub",
                    "item-class": "main-header__item",
                    "link-class": "main-header__link"
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "hamburger-box" }, [
      _c("span", { staticClass: "hamburger-inner" })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6db08cf2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db08cf2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/components/common/Navigation.vue
// module id = 259
// module chunks = 17